import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

export const money = (n) => `$${Number(n ?? 0).toFixed(Number(n) % 1 === 0 ? 0 : 2)}`;

export const EASE = [0.22, 1, 0.36, 1];

export const imgPos = () => "";
